export default {
  insurance: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  insured: {
    value: null,
    maxlength: '70',
    required: false,
    state: null
  },
  stage: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  sinisterCode: {
    value: null,
    maxlength: '20',
    required: false,
    state: null
  },
  sinisterVersion: {
    value: '',
    maxlength: '2',
    required: false,
    state: null
  },
  expert: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  expertID: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  analyst: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  sinisterDateStart: {
    value: '',
    maxlength: '10',
    required: false,
    state: null
  },
  sinisterDateEnd: {
    value: '',
    maxlength: '10',
    required: false,
    state: null
  },
  lighthouse: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  plate: {
    value: null,
    maxlength: '10',
    required: false,
    state: null
  },
  ranking: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  regulationType: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  schedulingType: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  budgetSystem: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  productID: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  product: {
    value: null,
    options: [],
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/regulation/auto/search/sinistersearch-form.js